<template>
  <div id="app" class="flex flex-col md:flex-row h-screen">
    <the-menu></the-menu>
    <the-mini-menu></the-mini-menu>
    <section class="p-4 md:p-12 overflow-y-auto w-screen">
      <peristock></peristock>
    </section>
  </div>
</template>

<script>
import TheMenu from "./components/layout/TheMenu.vue";
import TheMiniMenu from "./components/layout/TheMiniMenu.vue";
import Peristock from "./components/Peristock.vue";

export default {
  name: "App",
  components: {
    TheMenu,
    TheMiniMenu,
    Peristock,
  },
};
</script>
